import React from 'react';

function useInlinePagination(data = [], { defaultPage, defaultSize, sizes } = {}) {
  const [pagination, setPagination] = React.useState({
    currentPage: defaultPage ?? 1,
    size: defaultSize ?? sizes ? sizes[0] : 10,
  });

  const handlePaginationChange = React.useCallback((page, perPage) => {
    setPagination((o) => ({
      currentPage: page ?? o.currentPage,
      size: perPage ?? o.size,
    }));
  }, []);

  const handleSizeChange = React.useCallback((page, perPage) => {
    setPagination((o) => {
      const currentRecords = o.currentPage * o.size;
      const newPage = page === 1 ? 1 : Math.ceil(currentRecords / perPage);

      return {
        currentPage: newPage,
        size: perPage ?? o.size,
      };
    });
  }, []);

  const config = React.useMemo(
    () => ({
      current_page: pagination.currentPage,
      from: (pagination.currentPage - 1) * pagination.size + 1,
      to: Math.min(pagination.currentPage * pagination.size, data.length),
      total: data.length,
      last_page: Math.ceil(data.length / pagination.size),
      per_page: pagination.size,
    }),
    [data.length, pagination.currentPage, pagination.size]
  );

  const dataSlice = React.useMemo(() => {
    return (
      data.slice(
        (pagination.currentPage - 1) * pagination.size,
        pagination.currentPage * pagination.size
      ) || []
    );
  }, [pagination, data]);

  return {
    originalData: data,
    slicedData: dataSlice,
    paginationConfig: config,
    onChange: handlePaginationChange,
    onPageSizeChange: handleSizeChange,
  };
}

export default useInlinePagination;
